//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('fabricsGrps', {
//        templateUrl: 'views/components/views/fabricsGrps/fabricsGrps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'fabricsGrpsService', function (stateService, fabricsGrpsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.searchtext = '' }
//                ],
//                setting: {},
//                itemsListFabricGroups: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await fabricsGrpsService.getSetting())[0];
//            }

//            async function loadFabricGroups() {
//                vm.model.itemsListFabricGroups = (await fabricsGrpsService.listFabricGroups());
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'fabricsgrp':
//                        go({ fabricsgrp_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//                loadFabricGroups();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
